import { graphql } from "gql";

const MESSAGE_QUERY = graphql(`
  query Message($id: [ID!]!) {
    messages(id: $id) {
      ...Message
    }
  }
`);

export default MESSAGE_QUERY;
